import ajax from '@/utils/ajax.js'
export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async isLive() {
      const sessionId = sessionStorage.getItem('sessionId') || undefined
      const data = await ajax.post('/webapi/system-monitoring/v1/session/status', {
        data: {
          id: sessionId,
          userAgent: window.navigator.userAgent
        },
        toastError: false
      })
      sessionStorage.setItem('sessionId', data)
    },
    async monitoringEnt(ctx, { entId } = {}) {
      const sessionId = sessionStorage.getItem('sessionId')
      await ajax.post('/webapi/system-monitoring/v1/session/ent', {
        data: { sessionId, entId },
        toastError: false
      })
    }
  }
}
